angular
  .module('theme', [
    'ngCookies',
    'ngSanitize',
    'ngAnimate',
    'ui.bootstrap',
    'theme.core.template_overrides',
    'theme.core.panels',
    'theme.core.tiles',
    'theme.core.tiles',
    'theme.core.progressbar',
    'theme.core.main_controller',
    'theme.core.directives',
    'theme.core.filters',
  ]);